import { jsx as _jsx } from "react/jsx-runtime";
import "./index.less";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./contexts/AuthContext";
import { PageProvider } from "./contexts/PageContext";
import { ToastProvider } from "./contexts/ToastContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import App from "./pages/App";
async function prepare() {
    if (process.env.BUILD_TARGET === "dev:local") {
        const { worker } = await import("./mocks/browser");
        return worker.start({ onUnhandledRequest: "bypass" });
    }
    return;
}
const rootElement = document.getElementById("root");
if (!rootElement) {
    throw new Error("Root element not found");
}
void prepare().then(() => {
    createRoot(rootElement).render(_jsx(StrictMode, { children: _jsx(ThemeProvider, { children: _jsx(AuthProvider, { children: _jsx(PageProvider, { children: _jsx(ToastProvider, { children: _jsx(App, {}) }) }) }) }) }));
});
